<template>
  <div>
    <v-card outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">
            Hello Groups
          </div>
          <v-spacer />
          <v-select
            v-model="selectedFilter"
            :items="selectOptions"
            hide-details
            dense
            flat
            outlined
            label="Filter groups"
            solo
            clearable
            style="max-width: 200px"
          />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showCard">
          <v-skeleton-loader
            v-if="loading"
            class="mx-auto"
            type="table: table-thead, table-tbody"
          />
          <template v-else>
            <v-list>
              <v-list-item class="d-flex justify-space-evenly flex-wrap my-2">
                <v-chip
                  v-for="group in helloGroups"
                  :key="group.id"
                  :color="group.status === 'NORMAL' ? 'red' : ''"
                  class="mr-1 my-1"
                  :dark="group.status === 'NORMAL'"
                >
                  {{ group.name }}
                </v-chip>
              </v-list-item>
              <v-divider class="mx-5 my-2" />
            </v-list>
          </template>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import { requests } from '@/mixins/index';

export default {
  name: 'HelloGroupsCard',
  mixins: [requests],
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showCard: true,
      showContextModal: false,
      modalContext: null,
      loading: false,
      selectedFilter: null,
      dialogCreatAddContext: false
    };
  },
  computed: {
    helloGroups () {
      if (!this.content.helloGroups) {
        return [];
      }
      if (this.selectedFilter) {
        return this.selectedFilter === 'vacances'
          ? this.content.helloGroups.filter(g => g.context === 'vacances')
          : this.content.helloGroups.filter(g => g.centerDestinationName === this.selectedFilter);
      }
      return this.content.helloGroups;
    },
    selectOptions () {
      if (!this.content.helloGroups) {
        return [];
      }
      return this.content.helloGroups.reduce((options, g) => {
        if (g.context === 'vacances') {
          options.push({ text: 'Vacances', value: g.context });
          return options;
        }

        if (
          g.centerDestinationName
          && !options.includes(g.centerDestinationName)) {
          options.push({ text: g.centerDestinationName, value: g.centerDestinationName });
        }
        return options;
      }, []);
    }
  },
  methods: {}
};

</script>
<style scoped>
  .v-list {
    padding: 0;
  }
  .v-list-item {
    min-height: 0;
  }
</style>
